<!-- <div *ngIf="!hidden" [dir]="_translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
  class="alert alert-danger " role="alert">
    <p >{{'PRINTER.ERROR_MSG' | translate}}</p>
  <div class="spacer"></div>
  <div class="d-flex align-items-center p-8">
      <button class="col-sm-6"  color="accent" mat-raised-button (click)="downloadPrinterApp()">{{'COMMON.FIX' | translate}}</button>
      <button class="col-sm-6 m-x-6"  mat-stroked-button (click)="hide()">{{'COMMON.HIDE' | translate}}</button>
  </div>
</div> -->
<div [dir]="_translate.currentLang === 'ar' ? 'rtl' : 'ltr'" class="alert-dialog">
  <h2 mat-dialog-title>{{ 'PRINTER.ERROR_MSG' | translate }}</h2>
  <mat-dialog-content>
    <p>{{ 'PRINTER.ERROR_MSG' | translate }}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-raised-button color="accent" (click)="downloadPrinterApp()">{{ 'COMMON.FIX' | translate }}</button>
    <button mat-stroked-button (click)="hide()">{{ 'COMMON.HIDE' | translate }}</button>
  </mat-dialog-actions>
</div>
